import { useState } from "react";
import { Service } from "../types/service"; 

export function useServiceModal() {
  const [selectedService, setSelectedService] = useState<Service | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  const openModal = (service: Service) => {
    setSelectedService(service);
    setIsOpen(true);
  };

  const closeModal = () => {
    setSelectedService(null);
    setIsOpen(false);
  };

  return { selectedService, isOpen, openModal, closeModal };
}


export {};
